import styles from "./spinner.module.css";

const Spinner = () => (
  <img src="/assets/spinner.png" alt="spinner" className={styles.spinner} />
);

export default Spinner;
